import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
import { InfoBox } from '../../components/InfoBox';
interface CheckoutHostedPaymentPageProps {
  onNavigate?: (pageId: string) => void;
}
export function CheckoutHostedPaymentPage({
  onNavigate
}: CheckoutHostedPaymentPageProps) {
  return <DocPageLayout title="Implementing the <<hostedPaymentPage>>" data-id="element-1242">
      <div className="text-sm text-gray-500 mb-6 -mt-8" data-id="element-1243">
        <button onClick={() => onNavigate?.('overview')} className="hover:underline text-orange-600" data-id="element-1244">
          Overview
        </button>{' '}
        &gt;{' '}
        <button onClick={() => onNavigate?.('checkout')} className="hover:underline text-orange-600" data-id="element-1245">
          &lt;&lt;checkout&gt;&gt;
        </button>{' '}
        &gt; Implementing the &lt;&lt;hostedPaymentPage&gt;&gt;
      </div>

      <p className="text-gray-700 mb-6" data-id="element-1246">
        Once you have created a checkout session, you can display the hosted
        payment page to the payer. There are two display modes available:{' '}
        <strong data-id="element-1247">Lightbox</strong> and <strong data-id="element-1248">Payment Page</strong>.
      </p>

      <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1249">
        Include the Library
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1250">
        Add the Checkout.js library to your HTML page. The library is hosted by
        the gateway.
      </p>
      <CodeBlock language="HTML" title="Script Include" code={`<script src="https://test-gateway.mastercard.com/checkout/version/72/checkout.js"
        data-error="errorCallback"
        data-cancel="cancelCallback">
</script>`} data-id="element-1251" />

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1252">
        Lightbox Mode
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1253">
        The lightbox displays the payment form as an overlay on your page. The
        payer stays on your site while completing the payment.
      </p>
      <CodeBlock language="JavaScript" title="Lightbox Configuration" code={`Checkout.configure({
  session: {
    id: "SESSION000212345678901234567890"
  },
  interaction: {
    merchant: {
      name: "Your Store",
      logo: "https://your-site.com/logo.png"
    }
  }
});

// Trigger lightbox when user clicks Pay
document.getElementById('pay-btn').addEventListener('click', function() {
  Checkout.showLightbox();
});`} data-id="element-1254" />

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1255">
        Payment Page Mode
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1256">
        The payment page mode redirects the payer to a full-screen payment page
        hosted by the gateway.
      </p>
      <CodeBlock language="JavaScript" title="Payment Page Redirect" code={`Checkout.configure({
  session: {
    id: "SESSION000212345678901234567890"
  }
});

// Redirect to full payment page
Checkout.showPaymentPage();`} data-id="element-1257" />

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1258">
        Comparison
      </h2>
      <div className="overflow-x-auto mb-8" data-id="element-1259">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-1260">
          <thead data-id="element-1261">
            <tr className="bg-gray-50" data-id="element-1262">
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1263">
                Feature
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1264">
                Lightbox
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1265">
                Payment Page
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-1266">
            <tr data-id="element-1267">
              <td className="px-4 py-3" data-id="element-1268">User stays on your site</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1269">✓</td>
              <td className="px-4 py-3 text-gray-400" data-id="element-1270">—</td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-1271">
              <td className="px-4 py-3" data-id="element-1272">Full-screen experience</td>
              <td className="px-4 py-3 text-gray-400" data-id="element-1273">—</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1274">✓</td>
            </tr>
            <tr data-id="element-1275">
              <td className="px-4 py-3" data-id="element-1276">Mobile optimized</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1277">✓</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1278">✓</td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-1279">
              <td className="px-4 py-3" data-id="element-1280">Popup blocker safe</td>
              <td className="px-4 py-3 text-gray-400" data-id="element-1281">—</td>
              <td className="px-4 py-3 text-green-600" data-id="element-1282">✓</td>
            </tr>
          </tbody>
        </table>
      </div>

      <InfoBox type="warning" title="Popup Blockers" data-id="element-1283">
        The lightbox mode may be affected by popup blockers in some browsers.
        Consider using the payment page mode as a fallback.
      </InfoBox>
    </DocPageLayout>;
}